import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityApplicationsObjectsSlice } from './get';

export const coreDataSecurityApplicationsObjectsReducers = combineReducers({
	get: getCoreDataSecurityApplicationsObjectsSlice.asyncReducers
});

export const coreDataSecurityApplicationsObjectsWatchers = combineAllWatchers([
	getCoreDataSecurityApplicationsObjectsSlice.asyncWatchers
]);
